import { useGraviChatStore } from '@/components/GraviChat/store'
import { useMutation } from '@tanstack/react-query'
import { GraviRequestError, graviSend } from './request'

/**
 * Cancel a running task. Ported from S&D `api/gravi/useCancelTask.ts`.
 *
 * The caller flips status to 'cancelling' optimistically before firing this; on
 * failure we restore it to 'streaming' atomically so the Stop button isn't
 * permanently disabled, and surface the error inline.
 *
 * TODO(genapi): swap to `$api.useMutation('post', '/gravitutor/tasks/{task_id}/cancel')`
 * once the path is in the generated OpenAPI types.
 */
export function useCancelTask() {
  return useMutation({
    mutationFn: (taskId: string) =>
      graviSend<void>('POST', `/gravitutor/tasks/${taskId}/cancel`),
    onError: (error) => {
      const detail =
        error instanceof GraviRequestError ? error.detail : undefined
      const text =
        typeof detail === 'string'
          ? detail
          : 'Could not cancel — Gravi may still be working.'
      useGraviChatStore.getState().setSubmitError(text)
      // The status was flipped to 'cancelling' optimistically before the
      // request; restore it atomically so the Stop button isn't stuck.
      useGraviChatStore.setState((s) =>
        s.status === 'cancelling' ? { status: 'streaming' } : {},
      )
    },
  })
}
